export enum Action {
    CREATE = 'CREATE',
    EDIT = 'EDIT'
}